import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface IViolation extends Record<string, string | undefined> {
  description?: string;
  store_guid?: string;
  reason_report_guid?: string;
}

const initialState: IViolation = {};

export const violationStoreSlice = createSlice({
  name: 'violationStore',
  initialState,
  reducers: {
    addViolation: (state, action: PayloadAction<IViolation>) => {
      Object.keys(action.payload).map(item => {
        //@ts-ignore
        return (state[item] = action.payload[item]);
      });
    },
    resetViloation: (state, action: PayloadAction<IViolation>) => {
      state.description = '';
      state.reason_report_guid = '';
    },
  },
});

export const {addViolation, resetViloation} = violationStoreSlice.actions;

export default violationStoreSlice.reducer;
